import * as actionTypes from "./actionTypes";

export const fetchExchangeActivity = payload => ({
    type: actionTypes.fetchExchangeActivityType,
    payload,
  });
  export const singleExchangesIOD = payload => ({
    type: actionTypes.fetchEaSingleDataType,
    payload,
  });

export const setExchangeType = payload => ({
  type:actionTypes.setExchangeType,
  payload,
})

export const cancelTxnSchedule = payload => ({
  type: actionTypes.cancelTxnScheduleType,
  payload,
})

export const cancelReSchedule = payload => ({
  type: actionTypes.cancelReScheduleType,
  payload,
})

export const setTab = payload => ({
  type:actionTypes.setTabType,
  payload,
})